import { render, staticRenderFns } from "./RbEventHeader.vue?vue&type=template&id=4ab30e48&"
import script from "./RbEventHeader.vue?vue&type=script&lang=js&"
export * from "./RbEventHeader.vue?vue&type=script&lang=js&"
import style0 from "./RbEventHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports